import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const BlockedDomainsOption: LazyOption = createLazyOption(
    {
        key: 'blockedDomains',
        titleStringKey: 'optionTitle_blockedDomains',
        searchTermsStringKey: 'optionSearchTerms_blockedDomains',
        allowedOptionKeys: ['BlockSenders'],
        isHidden: () => {
            return isFeatureEnabled('tri-spamV2SenderDomain') || IsShadowMailboxUser();
        },
    },
    lazyFullModule,
    m => m.default
);
export default BlockedDomainsOption;
